export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/ceo-quote-open.3cb64f7a-fd8bac.svg";